import CartButton from '@components/cart/CartButton';
import Header from '@components/Header';
import useProject from '@hooks/useProject';
import { useAtom } from 'jotai';

import { isPersonalOptionOpenAtom } from '../../atoms/itemOptionAtoms';

interface Props {
    shopId: string;
    itemId: string;
}

function ItemHeader({ shopId, itemId }:Props) {
  const [isOpen, setIsOpen] = useAtom(isPersonalOptionOpenAtom);
  const close = () => setIsOpen(false);
  const project = useProject();
  return (
        <Header title='주문하기'
                trailing={project?.features.orderEnabled
                  ? <CartButton shopId={shopId}/> : undefined}
                onBackClick={isOpen ? close : undefined}
        />
  );
}

export default ItemHeader;
